import React from 'react';
import CustomModal from '../../../components/customModal/CustomModal';
import { Button } from 'react-bootstrap';

export interface WarningActionDialogProps {
    id?: string;
    show: boolean;
    title?: string;
    message?: string;
    children?: React.ReactNode;
    onAccept: () => void;
    onCancel: () => void;
    acceptText?: string;
    cancelText?: string;
}

const WarningActionDialog: React.FC<WarningActionDialogProps> = ({
    id = "WarningActionModal",
    show,
    title = "Warning",
    message,
    children,
    onAccept,
    onCancel,
    acceptText = "Continue",
    cancelText = "Cancel",
}) => {
    if (!show) return null;

    return (
        <CustomModal
            id={id}
            title={title}
            content={
                <div>
                    {message && <p className='warning-message'>{message}</p>}
                    {children}
                    <div className="d-flex gap-2 justify-content-end mt-4">
                        <Button variant="outline-primary" onClick={onCancel}>
                            {cancelText}
                        </Button>
                        <Button variant="primary" onClick={onAccept}>
                            {acceptText}
                        </Button>
                    </div>
                </div>
            }
        />
    );
};

export default WarningActionDialog;
